import { Box } from '@wix/design-system';
import {
  GtmEvents,
  PackagePickerSteps,
  useGtmLogger,
} from '@wix/package-picker-shared';
import {
  Checkout,
  PageDisclaimer,
  TrustBuilders,
  useInitCheckoutPageBiEvents,
  useStudioPanorama,
  useViewChange,
} from '@wix/package-picker-shared-studio';
import React from 'react';
import { PageLayout } from '../../components';
import { StudioPackagePickerModule } from '../../modules/studio-package-picker.module';

export const CheckoutPage = () => {
  const handleViewChange = useViewChange();
  const { t } = StudioPackagePickerModule.internals.useTranslations();
  useGtmLogger(GtmEvents.CHECKOUT);
  useInitCheckoutPageBiEvents();

  const handleBack = () => {
    StudioPackagePickerModule.internals.bi.onBackButtonClick?.({
      fromStep: 'checkout',
    });
    handleViewChange(PackagePickerSteps.SELECT_CYCLE, { cycleId: null });
  };
  const panorama = useStudioPanorama();

  React.useEffect(() => {
    panorama.startTransaction('checkout-page-load');
  }, []);

  return (
    <PageLayout
      onBack={handleBack}
      backButtonText={t('Advanced.Plans_Steps_Step2')}
    >
      <Box margin="SP7 SP5 SP5 SP5">
        <Checkout shouldOpenDoublePurchaseModal />
      </Box>
      <PageDisclaimer />
      <TrustBuilders />
    </PageLayout>
  );
};
